// User role enum - must match backend enum values
export enum UserRole {
  NONE = 0,
  ESTABLISHMENT = 1,
  STAFF = 2,
  ADMIN = 3,
  MANAGER = 4,
}

// User status enum - must match backend enum values
export enum UserStatus {
  CREATED = 0, // Created but not verified
  PENDING_VERIFICATION = 1, // Verified but not setup complete
  VERIFIED = 2, // Verified and setup complete
  DELETED = 3, // Deleted by user
  BLOCKED = 4, // Blocked by admin
}

// Helper function to get role display name
export const getRoleDisplayName = (role: number): string => {
  switch (role) {
    case UserRole.ADMIN:
      return "Admin";
    case UserRole.MANAGER:
      return "Manager";
    case UserRole.STAFF:
      return "Staff";
    case UserRole.ESTABLISHMENT:
      return "Establishment";
    case UserRole.NONE:
      return "None";
    default:
      return "Unknown";
  }
};

// Helper function to get status display name
export const getUserStatusDisplayName = (status: number): string => {
  switch (status) {
    case UserStatus.CREATED:
      return "Created";
    case UserStatus.PENDING_VERIFICATION:
      return "Pending Verification";
    case UserStatus.VERIFIED:
      return "Verified";
    case UserStatus.DELETED:
      return "Deleted";
    case UserStatus.BLOCKED:
      return "Blocked";
    default:
      return "Unknown";
  }
};

// Helper function to get role from display name
export const getRoleFromDisplayName = (displayName: string): number | undefined => {
  const normalizedName = displayName.toLowerCase();
  switch (normalizedName) {
    case "admin":
      return UserRole.ADMIN;
    case "manager":
      return UserRole.MANAGER;
    case "staff":
      return UserRole.STAFF;
    case "establishment":
      return UserRole.ESTABLISHMENT;
    case "none":
      return UserRole.NONE;
    default:
      return undefined;
  }
};

